import { useMemo } from "react";
import { getQuerySkipFlagsForConfiguredColumns } from "Utils";
import { useStandardsConfigureColumns } from "StandardsTable/hooks";
import { DATA_SET_COLUMNS_SETTING } from "Constants/permissionConstants";
import {
  DEFAULT_HIDDEN_COLUMNS,
  COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_FILTERS_QUERY,
  COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_TAGGED_IN_QUERY,
} from "../modules/Constants";

import {
  getCurrentColumns,
  getNonConfigurableColumns,
  getExtraFilters,
  getNodeSetFilters,
} from "../modules/Utils";

const useQueryVariables = ({
  defaultColumns,
  academicSetupType,
  moduleType,
  plannerElementType,
  disableUntaggingIfTaggedInOtherEntities,
  sideNavigationTab,
  parentNodesData,
  dynamicFilters,
  nodeSetFilters,
  allowedColumns,
}) => {
  const _defaultColumns = useMemo(() => {
    return (
      defaultColumns ||
      getCurrentColumns({
        academicSetupType,
        plannerElementType,
        allowedColumns,
        moduleType,
      })
    );
  }, [
    academicSetupType,
    plannerElementType,
    allowedColumns,
    defaultColumns,
    moduleType,
  ]);
  const {
    columnIdsForConfigureModal,
    currentColumns,
    updateColumns,
  } = useStandardsConfigureColumns({
    settingName: DATA_SET_COLUMNS_SETTING,
    moduleName: `${moduleType}_DatasetsTaggingModal`,
    defaultColumns: _defaultColumns,
    defaultHiddenColumns: DEFAULT_HIDDEN_COLUMNS,
    nonConfigurableColumns: getNonConfigurableColumns({
      plannerElementType,
      defaultColumns: _defaultColumns,
    }),
  });

  const skipFlagsForFiltersData = getQuerySkipFlagsForConfiguredColumns({
    configuredColumns: _defaultColumns,
    columnTypeMapToSkipFlags: COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_FILTERS_QUERY,
  });

  const skipFlagsForTaggedInQuery = getQuerySkipFlagsForConfiguredColumns({
    configuredColumns: disableUntaggingIfTaggedInOtherEntities
      ? _defaultColumns
      : currentColumns,
    columnTypeMapToSkipFlags: COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_TAGGED_IN_QUERY,
  });

  const updatedDynamicFilters = useMemo(() => {
    const extraFilters = getExtraFilters({
      sideNavigationTab,
      plannerElementType,
      parentNodesData,
    });
    return { ...dynamicFilters, ...extraFilters };
  }, [dynamicFilters, sideNavigationTab, plannerElementType, parentNodesData]);

  const updatedNodeSetFilters = useMemo(() => {
    const updatedNodeSetFilters = getNodeSetFilters({
      sideNavigationTab,
      plannerElementType,
      parentNodesData,
    });
    return { ...updatedNodeSetFilters, ...nodeSetFilters };
  }, [nodeSetFilters, sideNavigationTab, plannerElementType, parentNodesData]);
  return {
    columnIdsForConfigureModal,
    updateColumns,
    currentColumns,
    defaultColumns: _defaultColumns,
    skipFlags: { skipFlagsForFiltersData, skipFlagsForTaggedInQuery },
    dynamicFilters: updatedDynamicFilters,
    nodeSetFilters: updatedNodeSetFilters,
  };
};

export default useQueryVariables;
